import { getShouldUseZendeskSandbox } from "@faire/help-center-utils/serialized-data/getShouldUseZendeskSandbox";

export const RETAILER_WHAT_IS_FAIRE_ID = getShouldUseZendeskSandbox()
  ? "14674140629275"
  : "360015892572";

export const EU_DSA_ID = getShouldUseZendeskSandbox()
  ? "21720888406811"
  : "20960200105115";

export const FAIRE_ACCOUNT_SECURITY_ID = getShouldUseZendeskSandbox()
  ? "14674263970459"
  : "4408644893851";

export const BRAND_POLICIES_ID = getShouldUseZendeskSandbox()
  ? "14685390956443"
  : "360019040511";

export const WHERE_IS_FAIRE_AVAILABLE_ID = getShouldUseZendeskSandbox()
  ? "14674166031003"
  : "360016111311";

export const BECOME_BRAND_ID = getShouldUseZendeskSandbox()
  ? "14684624134299"
  : "360015479092";

export const FAIRE_COST_ID = getShouldUseZendeskSandbox()
  ? "14684483173659"
  : "360015893392";

export const ORDER_INVOICE_ID = getShouldUseZendeskSandbox()
  ? "14685198291355"
  : "360019493092";

export const ACCEPTING_ORDER_ID = getShouldUseZendeskSandbox()
  ? "14685105474843"
  : "360006685351";

export const WORD_FROM_CEO_ID = getShouldUseZendeskSandbox()
  ? "14674570252315"
  : "360004620392";

export const HOW_DO_NET_60_TERMS_WORK_ID = getShouldUseZendeskSandbox()
  ? "14675312474523"
  : "360016658851";

export const HOW_SHOULD_I_BE_SELLING_MY_FAIRE_PRODUCTS_ID =
  getShouldUseZendeskSandbox() ? "14675008853531" : "360047925272";

export const HOW_AM_I_NOTIFIED_NEW_ORDERS_ID = getShouldUseZendeskSandbox()
  ? "14685133526299"
  : "360006666951";

export const CONTACTING_MY_RETAILER_ID = getShouldUseZendeskSandbox()
  ? "14684662536091"
  : "360006915652";

export const PAYOUT_CALCULATED_ID = getShouldUseZendeskSandbox()
  ? "14685300144411"
  : "360006856911";

export const PAYOUT_EUROPEAN_ID = getShouldUseZendeskSandbox()
  ? "22825489075739"
  : "1260807391309";

export const PAYOUT_AUSTRALIAN_ID = getShouldUseZendeskSandbox()
  ? "22825471980315"
  : "1260807391309";

export const PAYOUT_CANADIAN_ID = getShouldUseZendeskSandbox()
  ? "22825466000795"
  : "19879402447643";

export const ISSUE_WITH_MY_ORDER_PAYOUT_ID = getShouldUseZendeskSandbox()
  ? "14685295538459"
  : "360006915532";

export const TAX_FORM_1099_ID = getShouldUseZendeskSandbox()
  ? "14685302136475"
  : "360022603552";

export const SETTING_UP_PAYOUT_ID = getShouldUseZendeskSandbox()
  ? "22825471980315"
  : "22825454667035";

export const TROUBLESHOOTING_WITH_ADYEN_ID = getShouldUseZendeskSandbox()
  ? "14685306076059"
  : "4404428415899";

export const NAM_SELL_ON_FAIRE_ID = getShouldUseZendeskSandbox()
  ? "22174219389723"
  : "360015893392";

export const NON_NAM_SELL_ON_FAIRE_ID = getShouldUseZendeskSandbox()
  ? "22825471901083"
  : "360040446591";

export const DISPUTE_A_RETAILER_COMPLAINT_ID = getShouldUseZendeskSandbox()
  ? "14685393455131"
  : "360007190491";

export const MAKE_A_RETURN_ID = getShouldUseZendeskSandbox()
  ? "14677185138971"
  : "360002924031";

export const ORDER_STATUS_ID = getShouldUseZendeskSandbox()
  ? "14674934260507"
  : "360006919652";

export const CANCELING_AN_ORDER_ID = getShouldUseZendeskSandbox()
  ? "14674935583003"
  : "360006919932";

export const REPORT_DAMAGED_MISSING_ID = getShouldUseZendeskSandbox()
  ? "14675107592475"
  : "360003687811";

export const CONTACT_A_BRAND_ID = getShouldUseZendeskSandbox()
  ? "14674871098651"
  : "360016145111";

export const SHOP_PERFORMANCE_ANALYTICS_ID = getShouldUseZendeskSandbox()
  ? "14684701411739"
  : "360022926871";

export const BUILDING_POSITIVE_REPUTATION_ID = getShouldUseZendeskSandbox()
  ? "14685030773659"
  : "360030186831";

export const BRAND_STORY_GUIDELINES_ID = getShouldUseZendeskSandbox()
  ? "14685059617947"
  : "360026756912";

export const COVER_IMAGE_GUIDELINES_ID = getShouldUseZendeskSandbox()
  ? "14685036473115"
  : "360016791851";

export const FEATURE_IMAGE_GUIDELINES_ID = getShouldUseZendeskSandbox()
  ? "14685037374491"
  : "360016565412";

export const HOW_OFTEN_CAN_I_UPDATE_CONTENT_ID = getShouldUseZendeskSandbox()
  ? "14685003767963"
  : "360017742212";

export const WHAT_ARE_BRAND_TAGS_ID = getShouldUseZendeskSandbox()
  ? "14684700013339"
  : "11200716008219";

export const LOCATION_SHOP_LIVE_ID = getShouldUseZendeskSandbox()
  ? "14684702638235"
  : "360016524391";

export const WHAT_ARE_SOCIAL_SELLERS_ID = getShouldUseZendeskSandbox()
  ? "14685205865755"
  : "360059304192";

export const WHAT_ARE_LEAD_TIMES_ID = getShouldUseZendeskSandbox()
  ? "14684722481051"
  : "360018234592";

export const FULFILLING_SCHEDULED_ORDERS_ID = getShouldUseZendeskSandbox()
  ? "14685156186395"
  : "360023295651";

export const ADD_EDIT_PRODUCTS_ID = getShouldUseZendeskSandbox()
  ? "14684834141723"
  : "360006829831";

export const CAN_I_EDIT_PRODUCTS_IN_BULK_ID = getShouldUseZendeskSandbox()
  ? "14684834844827"
  : "4723261199899";

export const HOW_DO_I_ADD_PRODUCTS_USING_THE_BULK_UPLOADER_ID =
  getShouldUseZendeskSandbox() ? "14684891531547" : "360055762471";

export const HOW_DO_I_OFFER_FOOD_AND_DRINK_SAMPLES_ID =
  getShouldUseZendeskSandbox() ? "14684882614299" : "10967509982491";

export const PREORDERS_ID = getShouldUseZendeskSandbox()
  ? "14684842931355"
  : "360059869212";

export const APPAREL_PREORDERS_ID = getShouldUseZendeskSandbox()
  ? "14684838690587"
  : "9203429758363";

export const WHAT_IS_PREPACK_ID = getShouldUseZendeskSandbox()
  ? "14684887833627"
  : "360040440352";

export const PRODUCT_ATTRIBUTES_AND_DETAILS_ID = getShouldUseZendeskSandbox()
  ? "27963934821019"
  : "13314888438683";

export const WILL_YOU_LIST_ALL_PRODUCTS_ID = getShouldUseZendeskSandbox()
  ? "14684521168155"
  : "360015893192";

export const CAN_I_INTEGRATE_WITH_SHOPIFY_ID = getShouldUseZendeskSandbox()
  ? "14685032071451"
  : "360054245292";

export const HOW_DOES_SHOPIFY_PRICE_SYNC_WORK_ID = getShouldUseZendeskSandbox()
  ? "30587808476955"
  : "26403322998555";

export const PRESTASHOP_INTEGRATION_WITH_FAIRE_ID = getShouldUseZendeskSandbox()
  ? "26219169738523"
  : "8726114634779";

export const WOOCOMMERCE_INTEGRATION_WITH_FAIRE_ID =
  getShouldUseZendeskSandbox() ? "14685001431067" : "7656909641243";

export const SUBMIT_REQUEST_TO_ADD_OR_EDIT_PRODUCTS_ID =
  getShouldUseZendeskSandbox() ? "14684881443739" : "360026429691";

export const OPEN_SIZING_ID = getShouldUseZendeskSandbox()
  ? "14684887600027"
  : "360060351591";

export const CUSTOMIZE_MY_PRODUCT_TRANSLATIONS_ID = getShouldUseZendeskSandbox()
  ? "14684835196699"
  : "7652446722331";

export const SELLING_AND_IMPORTING_PRODUCTS_INTO_EU_ID =
  getShouldUseZendeskSandbox() ? "14685190756507" : "12993868647707";

export const CURRENCY_SPECIFIC_PRICING_ID = getShouldUseZendeskSandbox()
  ? "14684836384155"
  : "360055558732";

export const SOFTWARE_INTEGRATION_WITH_FAIRE_ID = getShouldUseZendeskSandbox()
  ? "14684770152475"
  : "360037964391";
